import request from "@/utils/request";

export default function updateDeviceStatus(data) {
    return request({
        url: '/camera/updateDeviceStatus',
        method: 'post',
        data: data
    })
}
